import Sidebar from "./SideBar.vue";

const SidebarStore = {
    showSidebar: false,
    sidebarLinks: [],
    displaySidebar(value) {
        this.showSidebar = value;
    }
};

const SidebarPlugin = {
    install(Vue) {
        let app = new Vue({
            data: {
                sidebarStore: SidebarStore
            }
        });

        Vue.prototype.$sidebar = app.sidebarStore;
        Vue.component("side-bar", Sidebar);
    }
};

export default SidebarPlugin;



// WEBPACK FOOTER //
// ./src/components/SidebarPlugin/index.js